import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';
import { Theme } from '@slal/ui/theme';
import { StepState } from './types';

const getProgressColor = (theme: Theme, state: StepState) => {
    const colorMap: Record<StepState, string> = {
        previous: theme.colors.green__70,
        current: theme.colors.aqua__60,
        next: theme.colors.neutral__light__40,
    };
    return colorMap[state];
};

export const ProgressBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 190px;
    margin-left: 24px;
    ${breakpointUp.sm`
        margin-left: 0;
      `}
`;

export const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
`;

export const ProgressIndicator = styled.div<{ state: StepState }>`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${({ theme, state }) => getProgressColor(theme, state)};
    background-color: ${({ state, theme }) => (state === 'previous' ? theme.colors.green__70 : 'transparent')};
    color: ${({ state }) => (state === 'previous' ? 'white' : 'transparent')};
    svg {
        width: 12px;
        height: 12px;
    }
`;

export const StepIndicatorText = styled.span`
    font-size: ${({ theme }) => theme.fontSizes[3]};
    color: ${({ theme }) => theme.colors.neutral__light__80};
    margin-top: 8px;
    text-align: center;
`;

export const Line = styled.div<{ isCompleted: boolean }>`
    position: absolute;
    top: 10px;
    left: 8px;
    transform: translateX(12px);
    width: 56px;
    height: 2px;
    background-color: ${({ theme, isCompleted }) =>
        isCompleted ? theme.colors.green__70 : theme.colors.neutral__light__40};
`;
